import type { MuiTableColumnWidthDefaults } from '../../hooks/useMuiTableColumnResize';

/** Default pixel widths for Customer Sentiment table columns (drag-resize baseline). */
export const CUSTOMER_SENTIMENT_DEFAULT_COLUMN_PX: MuiTableColumnWidthDefaults = {
  request_number: 160,
  requestNumber: 160,
  project_code: 120,
  projectCode: 120,
  project_name: 180,
  projectName: 180,
  account: 150,
  account_name: 150,
  project_account_bu: 128,
  region: 100,
  closure_date: 128,
  date: 112,
  date_raised: 128,
  created_at: 128,
  email_status: 140,
  customer_response_status: 160,
  feedback_status: 140,
  zoho_status: 140,
  zohoStatus: 140,
  zohoIssueLink: 140,
  status: 112,
  level: 112,
  type: 112,
  escalated_by: 150,
  customer_spoc: 150,
  customer_poc_name: 150,
  customer_poc_designation: 150,
  customerName: 140,
  customerEmail: 180,
  projectOwner: 140,
  project_owner: 140,
  submitter_email: 172,
  submitter_name: 150,
  submission_date: 128,
  date_testimony_received: 128,
  overallSatisfaction: 160,
  deliveryCompletion: 140,
  deliveryTimeline: 140,
  deliveryClosure: 160,
  teamTechnical: 140,
  teamSupport: 140,
  teamResponsiveness: 140,
  specificContributions: 200,
  areasForImprovement: 200,
  opportunity: 144,
  solution_story_link: 152,
  public_testimonial_link: 152,
  file_url: 96,
  link: 140,
  request_status: 160,
  solution_story_status: 180,
  id: 80,
};

export function visibleColumnConfigs<T extends { id: string }>(
  columns: T[],
  columnVisibility: Record<string, boolean | undefined>,
  activeTab: number,
): T[] {
  return columns.filter((col) => {
    if (col.id === 'id' && activeTab === 5) return false;
    return columnVisibility[col.id] !== false;
  });
}
